<template>
  <DragZoomContainer>
    <div class="topo-wrapper" id="topo-container"></div>
  </DragZoomContainer>
  <teleport to="body">
    <v-dialog v-model="dialogVisible" title="储能系统设备" width="80%">
      <div class="topo-designer__dialog-body">
        <div class="topo-designer__dialog-header">
          <span class="topo-designer__dialog-title">
            <v-icon size="18">mdi-battery-charging-60</v-icon>
            储能系统设备
          </span>
          <v-btn icon variant="text" size="small" density="comfortable" class="topo-designer__dialog-close"
            aria-label="关闭" @click="dialogVisible = false">
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>
        <DialogTopo :dialog-data="dialogData" />
      </div>
    </v-dialog>
  </teleport>
</template>

<script setup>
import { ref, reactive, computed, onMounted, onUnmounted, watch } from 'vue'
import { Topology } from '@/topo/core/topology'
import '@/topo/core/style.css'
import DragZoomContainer from '@/components/DragZoomContainer.vue'
import { useRealData } from '@/hooks/useRealData'
import { ws_req } from '@/ws/wss-request'
import { useRoute } from 'vue-router'
import DialogTopo from './dialog-topo.vue'

const route = useRoute()
const stationId = computed(() => route.query.stationId)

const dialogVisible = ref(false)
const dialogData = ref({})

const props = defineProps({
  topologyData: {
    type: Object,
    default: () => ({}),
  },
})

let topo = null

onMounted(() => {
  topo = new Topology({
    root: '#topo-container',
    editor: false,
    // wsUrl: appConfig.wsUrl,
  })
  if (props.topologyData) {
    topo.fromJSON(props.topologyData)
  }
  topo.addEventListener('topo:openESS', eventHandler)
})

watch(() => props.topologyData, (newVal) => {
  if (newVal && topo) {  
    topo.clear()
    topo.fromJSON(newVal)
  }
})


function updateRealData(res) {
  // console.log('----', res);

  const obj = {} //{uuid: {}}
  Object.keys(res).forEach(dataKey => {
    const dataMap = res[dataKey]
    Object.keys(dataMap).forEach(key => {
      obj[key] = dataMap[key]
    })
  })

  // 更新设备数据
  const devList = dialogData.value.childrenDataList || []
  for (const dev of devList) {
    dev._readData = obj[dev.uuid] || {}
  }

  ///////////////////////
  topo.updateData(obj)
}

const { updateOnce } = useRealData({
  updateFunction: () => {
    return ws_req.request('ws_device_diagram', {
      stationId: stationId.value
    })
  },
  onUpdate: updateRealData,
  interval: 5000,
  // immediate: false,
})


watch(stationId, (newVal) => {
  if (newVal) {
    updateOnce()
  }
})


onUnmounted(() => {
  topo?.clear()
  topo?.removeEventListener('topo:openESS', eventHandler)
})



function eventHandler(event) {
  dialogVisible.value = true
  dialogData.value = event.detail ?? {}
  updateOnce()
}

</script>
<style scoped>
.topo-wrapper {
  min-height: 760px;
  min-width: 1660px;
  flex: 0;
  /* background: rgb(15, 15, 15); */
  /* border-radius: 20px; */
  overflow: hidden;
  /* border: 1px solid blue; */
  display: flex;
}

.topo-designer__dialog-body {
  height: 600px;
  border-radius: 8px;
  overflow: hidden;
  background: linear-gradient(180deg, #f5f7fb 0%, #eef1f6 100%);
  border: 1px solid #e9efff;
  display: flex;
  flex-direction: column;
}

.topo-designer__dialog-header {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  padding: 0 12px 0 16px;
  background: rgba(255, 255, 255, 0.78);
  backdrop-filter: saturate(140%) blur(6px);
  -webkit-backdrop-filter: saturate(140%) blur(6px);
  border-bottom: 1px solid #e9efff;
}

.topo-designer__dialog-title {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
  letter-spacing: 0.02em;

  .v-icon {
    color: #2b57ee;
  }
}

.topo-designer__dialog-close {
  color: #9aa0b5;

  &:hover {
    color: #2b57ee;
    background: rgba(43, 87, 238, 0.08);
  }
}

.topo-designer__dialog-body :deep(.topo) {
  flex: 1;
  min-height: 0;
}
</style>
